import imgProxy from "~/utils/imgproxy";
import { urlRs } from "~/utils/url";

export default function SponsorshipMenu() {
  return (
    <>
      <span class="promo-sponsorship-menu">
        <picture>
          <img
            src={imgProxy(
              "/images/autopromos/sponsorship-menu-2.jpg",
              `size:270:240/resizing_type:fill`,
            )}
            alt=""
            height="240"
            width="270"
            loading="lazy"
          />
        </picture>
        <span class="inner">
          <span class="h3">Parrainez vos proches</span>
          <span class="paragraph">
            Et gagnez jusqu’à 8&nbsp;000&nbsp;€ de bons cadeaux&nbsp;!
          </span>
          <a
            class="btn"
            href={urlRs(
              "journeys",
              "/cogedim-pour-vous/parrainez-vos-proches/",
            )}
          >
            Je parraine
          </a>
        </span>
      </span>
    </>
  );
}
